export const DOCUMENTATION_URL = "https://prompt.studio/docs";
export const VITE_DISCORD_URL = "https://discord.com/invite/3RxwUEk8fW";
export const RUN_PROMPTBOOK_DOCS_URL = "https://prompt.studio/docs";

export const PRO_SUBSCRIPTION = "pro";
export const FREE_SUBSCRIPTION = "free";

export const BLANK_PROMPTBOOK_THUMBNAIL_URL =
  "http://localhost:8000/storage/v1/object/public/template_thumbnails/blank_promptbook.png";

export const DEFAULT_PROMPTBOOK_NAME = "Untitled Promptbook";
export const DEFAULT_TEAM_NAME = "Untitled Team";

export const ROLE_NAMES = {
  team_owner: "Owner",
  team_editor: "Editor",
  team_viewer: "Viewer",
};

export const QUICK_START_TEMPLATE = "dc442429-37ec-4ac8-bc30-4ae5edc9eb10";

export const PRO_SUBSCRIPTION_PERKS = [
  "100 monthly credits included",
  "Organize your promptbooks in workspaces",
  "Collaborate with your team members",
  "Role-based access",
  "Community support",
];

export const BUCKETS = {
  promptbooks: "promptbooks",
  "promptbook-templates": "promptbook-templates",
};
